(function () {
  'use strict';

  function initFeatured(section) {
    if (!section || section.dataset.dictacFeaturedInit) return;
    section.dataset.dictacFeaturedInit = 'true';

    var rail = section.querySelector('[data-dictac-featured-rail]');
    var progress = section.querySelector('[data-dictac-featured-progress]');
    var prev = section.querySelector('[data-dictac-featured-prev]');
    var next = section.querySelector('[data-dictac-featured-next]');

    if (!rail) return;

    window.DictacHome.initHorizontalRail(rail, {
      progressEl: progress,
      prevBtn: prev,
      nextBtn: next,
      preventClickOnDrag: true,
    });

    initFeaturedDots(section, rail);
  }

  function initFeaturedDots(section, rail) {
    var dots = Array.from(
      section.querySelectorAll('[data-dictac-featured-dot]')
    );
    var cards = Array.from(rail.querySelectorAll('.dictac-featured__card'));
    if (!dots.length || !cards.length) return;

    function isMobileLayout() {
      return window.matchMedia('(max-width: 620px)').matches;
    }

    function activeIndex() {
      var railLeft = rail.getBoundingClientRect().left;
      var index = 0;
      var best = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.getBoundingClientRect().left - railLeft);
        if (dist < best) {
          best = dist;
          index = i;
        }
      });
      return index;
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function syncDots() {
      if (!isMobileLayout()) return;
      setActive(activeIndex());
    }

    rail.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', syncDots);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var card = cards[Number(dot.dataset.index)];
        if (!card) return;
        var dest =
          rail.scrollLeft +
          (card.getBoundingClientRect().left -
            rail.getBoundingClientRect().left);
        rail.scrollTo({ left: dest, behavior: 'smooth' });
      });
    });

    syncDots();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dictac-featured]').forEach(initFeatured);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section =
      e.target.querySelector('[data-dictac-featured]') ||
      (e.target.matches('[data-dictac-featured]') ? e.target : null);
    if (section) initFeatured(section);
  });
})();
